import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details for debugging
        // console.error('ErrorBoundary caught an error:', error, errorInfo);
        
        // this.setState({
        //     error: error,
        //     errorInfo: errorInfo
        // });

        // You can also log the error to an error reporting service here
        // Example: Sentry.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            // Custom fallback UI
            return (
                <div 
                    className="error-boundary"
                    style={{
                        padding: '40px 20px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        margin: '20px 0',
                        color: '#6c757d'
                    }}
                    role="alert"
                    aria-live="assertive"
                >
                    <h2 style={{ color: '#dc3545', marginBottom: '16px' }}>
                        Oops! Something went wrong
                    </h2>
                    <p style={{ marginBottom: '20px' }}>
                        We apologize for the inconvenience. Please try refreshing the page or contact support if the problem persists.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            backgroundColor: '#f06c02',
                            color: 'white',
                            padding: '10px 20px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#e05a00'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#f06c02'}
                    >
                        Refresh Page
                    </button>
                    
                    {/* Development mode: show error details */}
                    {process.env.NODE_ENV === 'development' && (
                        <details style={{ marginTop: '20px', textAlign: 'left' }}>
                            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                Error Details (Development Only)
                            </summary>
                            <pre style={{ 
                                backgroundColor: '#f1f1f1', 
                                padding: '10px', 
                                borderRadius: '4px',
                                fontSize: '12px',
                                overflow: 'auto',
                                marginTop: '10px'
                            }}>
                                {this.state.error && this.state.error.toString()}
                                <br />
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
